/**
 * Converts a JSON object into a Map, optionally transforming values.
 * @param json - The JSON object to convert
 * @param keyParser - Function to convert keys from string → K
 * @param valueParser - Optional function to transform values from JSON → V
 */
export function jsonToMap<K = string, V = unknown>(
    json: Record<string, any>,
    keyParser: (key: string) => K = k => k as unknown as K,
    valueParser?: (value: any) => V
): Map<K, V> {
    const entries = Object.entries(json).map(([key, value]) => {
        const v = valueParser ? valueParser(value) : value;
        return [keyParser(key), v] as [K, V];
    });
    return new Map(entries);
}
